module.exports = "/images/gotham-15.jpg";